import { API, apiRequest } from "../api";
import {
    GetSimulateScoreRankReq,
    GetSimulateScoreRankRsp,
    GetUsedTimeRankReq,
    GetUsedTimeRankRsp,
} from "./rank";

const apiGetSimulateScoreRank: API<GetSimulateScoreRankReq, GetSimulateScoreRankRsp> = {
    url: "/api/rank/get_simulate_score",
};

const apiGetUsedTimeRank: API<GetUsedTimeRankReq, GetUsedTimeRankRsp> = {
    url: "/api/rank/get_used_time",
};

export function methodGetSimulateScoreRank(dispatch: any, req: GetSimulateScoreRankReq) {
    return apiRequest({ api: apiGetSimulateScoreRank, req, dispatch });
}

export function methodGetUsedTimeRank(dispatch: any, req: GetUsedTimeRankReq) {
    return apiRequest({ api: apiGetUsedTimeRank, req, dispatch });
}
